import merge from 'lodash/merge';
import sortBy from 'lodash/sortBy';
import DashboardWidgetController from 'dashboard/components/dashboard-widget/dashboard-widget-controller';
import { checkAccess } from 'app/actions/app.actions';
import { isStoreProfileSelector, isIndependentSelector, isChainSubordinateSelector } from 'selectors';
import * as api from 'dashboard/resources/cumulative-winners.api';
import template from './cumulative-winners-widget.html';

const CUMMULATIVE_HISTORY_PERMISSION = 'cumulativeWinners.history';

const mapStateToThis = ({ session, dictionary }) => {
  const { locale, retailer } = session;
  const isStoreProfile = isStoreProfileSelector({ session });
  const isIndependent = isIndependentSelector({ session });
  const isChainSubordinate = isChainSubordinateSelector({ session });
  const terms = dictionary.terms[locale];

  return {
    retailer,
    isIndependent,
    isChainSubordinate,
    isStoreProfile,
    terms,
  };
};

const mapDispatchToThis = {
  checkAccess,
};

// eslint-disable-next-line no-undef
@Inject('$scope', '$ngRedux', 'gettextCatalog', '$state')
class CumulativeWinnersWidgetController extends DashboardWidgetController {
  constructor() {
    super();
    this.unsubscribe = this.$ngRedux.connect(mapStateToThis, mapDispatchToThis)(this);
  }

  $onInit() {
    this.activeTabIdx = 0;
    this.isHistoryLinkVisible =
      (this.isIndependent || this.isChainSubordinate || this.isStoreProfile) && this.checkAccess(CUMMULATIVE_HISTORY_PERMISSION);
    const retailerId = this.$state.params.retailerNo || this.retailer.retailerId;
    this.loadDataAsync(() => api.fetchCumulativeWinners(retailerId), this.transformData.bind(this));
  }

  $onDestroy() {
    this.unsubscribe();
  }

  transformData(data) {
    const getTabInfo = (item) => {
      const info = {
        WTD: {
          title: this.gettextCatalog.getString('Paid to winners this week'),
          tabTitle: 'WTD',
          order: 1,
          periodType: 'WTD',
        },
        MTD: {
          title: this.gettextCatalog.getString('Paid to winners this month'),
          tabTitle: 'MTD',
          order: 2,
          periodType: 'MTD',
        },
        YTD: {
          title: this.gettextCatalog.getString('Paid to winners this year'),
          tabTitle: 'YTD',
          order: 3,
          periodType: 'YTD',
        },
      };

      return info[item.periodType];
    };

    return sortBy(
      data.reduce(
        (result, item) =>
          result.concat([
            merge(getTabInfo(item), {
              amount: item.validationAmount,
              wonDate: item.validationDate,
            }),
          ]),
        []
      ),
      ['order']
    );
  }
}

export default class CumulativeWinnersWidgetComponent {
  constructor() {
    this.template = template;
    this.controller = CumulativeWinnersWidgetController;
    this.bindings = {
      isEditMode: '<',
      isDisabledShare: '<',
      isRemovable: '<',
      removeWidget: '&?',
    };
  }
}



// WEBPACK FOOTER //
// ./src/modules/dashboard/components/dashboard-widget/cumulative-winners/cumulative-winners-widget-component.js